import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="bg-primary-2 footer-container">
      <h1 className="footer-title">SPIN RADIO</h1>
    </div>
  );
}
